class HHCustomerRegister extends HTMLElement {
  static properties = {
    firstNameInput: { type: String },
    lastNameInput: { type: String },
    emailInput: {
      type: String,
    },
    passwordInput: { type: String },
    registerFormTranslations: { type: Object },
  }

  constructor() {
    super()
    this.getRegisterFormTranslations()
  }

  connectedCallback() {
    const form = this.querySelector('#create_customer')

    this.addEventListener('keyup', (event) => {
      this.removeInputError()
    })
    if (form) {
      form.addEventListener('submit', async (event) => {
        const { target } = event

        this.firstNameInput = this.querySelector('#RegisterForm-FirstName')
        this.lastNameInput = this.querySelector('#RegisterForm-LastName')
        this.passwordInput = this.querySelector('#RegisterForm-password')
        this.passwordConfirmationInput = this.querySelector(
          '#RegisterForm-passwordConfirmation'
        )
        this.emailInput = this.querySelector('#RegisterForm-email')

        this.removeInputError()
        const hasError = this.hasErrors()
        target?.classList.toggle('has-errors', hasError)
        if (hasError) {
          this.displayErrors()
          this.focusFirstError()

          /* all of the below is needed to stop page refreshing */
          event.stopImmediatePropagation()
          event.preventDefault()
          return false
        }

        if (!hasError) {
          event.target.submit()
          return true
        }
      })
    }
  }

  async getRegisterFormTranslations() {
    try {
      const elem = this.querySelector('#register-form-translations')
      const elemData = JSON.parse(elem?.textContent)
        .replace(/&quot;/g, '"')
        .replace(/=&gt;/g, ':')
      this.registerFormTranslations = JSON.parse(elemData)
    } catch (err) {
      console.error('Error capturing Register Form Translations: ', err)
    }
  }
  createHashCode(s) {
    for (var h = 0, i = 0; i < s.length; h &= h) h = 31 * h + s.charCodeAt(i++)
    return h
  }
  inputErrorSlot(msg, errorId) {
    const elem = document.createElement('span')
    elem.classList.add('js-input-error', 'p-small')
    elem.setAttribute('slot', 'error')
    elem.setAttribute('id', errorId)
    elem.setAttribute('aria-live', 'polite')
    elem.setAttribute('aria-atomic', 'true')
    elem.innerHTML = `${msg}`
    return elem
  }
  hasValidEmail() {
    const regex = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$')
    const check = regex.test(this.emailInput?.value)
    return check
  }
  hasValidPassword() {
    // const lowerCaseRegex = new RegExp('[a-z]')
    // const upperCaseRegex = new RegExp('[A-Z]')
    // const digitRegex = new RegExp('[0-9]')
    // const specialCharRegex = new RegExp('[^\\w\\s]')

    // let matchCriteria = 0

    // if (lowerCaseRegex.test(this.passwordInput?.value)) matchCriteria++
    // if (upperCaseRegex.test(this.passwordInput?.value)) matchCriteria++
    // if (digitRegex.test(this.passwordInput?.value)) matchCriteria++
    // if (specialCharRegex.test(this.passwordInput?.value)) matchCriteria++

    // return matchCriteria >= 3 && this.passwordInput?.value.length >= 8
    return this.passwordInput?.value.length >= 5
  }
  hasValidPasswordConfirmation() {
    return this.passwordInput?.value === this.passwordConfirmationInput?.value
  }
  hasErrors() {
    return [
      this.firstNameInput?.value,
      this.lastNameInput?.value,
      this.emailInput?.value,
      this.hasValidEmail(),
      this.passwordInput?.value,
      this.hasValidPassword(),
      this.passwordConfirmationInput?.value,
      this.hasValidPasswordConfirmation(),
    ].some((v) => !v)
  }
  getErrors(field) {
    return this?.registerFormTranslations?.[field]
  }
  displayErrors() {
    if (!this.firstNameInput.value) {
      const msg = this.getErrors('first_name')
      this.setInputError(this.firstNameInput, msg)
    }
    if (!this.lastNameInput.value) {
      const msg = this.getErrors('last_name')
      this.setInputError(this.lastNameInput, msg)
    }
    if (!this.emailInput.value || !this.hasValidEmail()) {
      const msg = this.getErrors('email')
      this.setInputError(this.emailInput, msg)
    }
    if (!this.passwordInput.value || !this.hasValidPassword()) {
      const msg = this.getErrors('password')
      this.setInputError(this.passwordInput, msg)
    }
    if (
      !this.passwordConfirmationInput.value ||
      !this.hasValidPasswordConfirmation()
    ) {
      const msg = this.getErrors('password_confirmation')
      this.setInputError(this.passwordConfirmationInput, msg)
    }
  }
  focusFirstError() {
    const inputWithError = this.querySelector('input[aria-invalid="true"]')
    if (!inputWithError) {
      return
    }

    inputWithError.focus()
  }
  setInputError(input, msg) {
    const errorId = this.createHashCode(msg)
    input.parentElement.append(this.inputErrorSlot(msg, errorId))
    input.setAttribute('aria-invalid', 'true')
    input.setAttribute('aria-errormessage', errorId)
    input.setAttribute('aria-describedby', errorId)
  }
  removeInputError() {
    const form = this.querySelector('form')
    form?.classList.remove('has-errors')

    this.querySelectorAll('.js-input-error').forEach((el) => {
      el.parentElement.querySelector('input').removeAttribute('aria-invalid')
      el.remove()
    })
  }
}
customElements.define('hh-customer-register', HHCustomerRegister)
